// Erweitertes deutsches chrono-node für Datums-Freitexteingabe (flatpickr-Felder).
//
// chrono.de hat laut chrono-README nur "partial support" für Deutsch. Wir ergänzen daher
// gängige Business-Phrasen, die der Default nicht (zuverlässig) kann: Monatsende/-anfang,
// Anfang/Ende nächster Woche, Anfang/Ende nächsten Monats, Kalenderwoche (KW NN).
// Alles andere (heute, morgen, übermorgen, Wochentage, "in 3 Tagen", explizite Daten)
// erledigt weiterhin der eingebaute chrono.de-Parser.
//
// Verwendung:  import deChrono from '../src/datetime/de_chrono'
//              const res = deChrono.parse('nächsten Freitag', new Date(), { forwardDate: true })

import * as chrono from 'chrono-node'

// chrono.de ist ein Namespace; die konfigurierbare Chrono-Instanz ist chrono.de.casual.
const de = chrono.de.casual.clone()

// --- Datums-Helfer ---------------------------------------------------------
function lastDayOfMonth(ref, offsetMonths = 0) {
  return new Date(ref.getFullYear(), ref.getMonth() + 1 + offsetMonths, 0)
}
function firstDayOfMonth(ref, offsetMonths = 0) {
  return new Date(ref.getFullYear(), ref.getMonth() + offsetMonths, 1)
}
// nächster Wochentag (1=Mo … 7=So nach ISO; hier 0=So..6=Sa wie getDay()), strikt in Zukunft
function nextWeekday(ref, weekday) {
  const x = new Date(ref)
  const diff = ((weekday - x.getDay() + 7) % 7) || 7
  x.setDate(x.getDate() + diff)
  return x
}
// Montag der ISO-Kalenderwoche `week` im Jahr von `ref`
function isoWeekMonday(ref, week) {
  const jan4 = new Date(ref.getFullYear(), 0, 4)
  const week1Monday = new Date(jan4)
  week1Monday.setDate(jan4.getDate() - ((jan4.getDay() + 6) % 7))
  const d = new Date(week1Monday)
  d.setDate(week1Monday.getDate() + (week - 1) * 7)
  return d
}
function refOf(context) {
  // chrono v2: context.reference.instant ; defensiv mit Fallbacks
  return (context && context.reference && context.reference.instant)
    || (context && context.refDate)
    || new Date()
}
function comp(date) {
  return { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() }
}

// --- Phrasen-Regeln --------------------------------------------------------
// (ä auch als "ae" tolerieren)
const N = '(?:ä|ae)'
const RULES = [
  { re: new RegExp(`ende\\s+n${N}chsten\\s+monats?`, 'i'),       calc: (r) => lastDayOfMonth(r, 1) },
  { re: new RegExp(`(?:anfang|beginn)\\s+n${N}chsten\\s+monats?`, 'i'), calc: (r) => firstDayOfMonth(r, 1) },
  { re: new RegExp(`anfang\\s+n${N}chster\\s+woche`, 'i'),        calc: (r) => nextWeekday(r, 1) },
  { re: new RegExp(`ende\\s+n${N}chster\\s+woche`, 'i'),          calc: (r) => { const f = nextWeekday(r, 5); f.setDate(f.getDate() + 7); return f } },
  { re: /monatsende|ende\s+(?:des|vom)\s+monats?/i,               calc: (r) => lastDayOfMonth(r) },
  { re: /monatsanfang|anfang\s+(?:des|vom)\s+monats?/i,           calc: (r) => firstDayOfMonth(r) },
  { re: /wochenende|ende\s+der\s+woche/i,                         calc: (r) => nextWeekday(r, 5) },
]
const UNION = new RegExp(RULES.map((x) => `(?:${x.re.source})`).join('|'), 'i')

de.parsers.push({
  pattern: () => UNION,
  extract: (context, match) => {
    const text = match[0]
    const rule = RULES.find((x) => x.re.test(text))
    if (!rule) return null
    return comp(rule.calc(refOf(context)))
  },
})

// Kalenderwoche: "KW 27", "KW27", "Kalenderwoche 27" -> Montag dieser ISO-Woche
de.parsers.push({
  pattern: () => /\b(?:KW|Kalenderwoche)\s?(\d{1,2})\b/i,
  extract: (context, match) => {
    const week = parseInt(match[1], 10)
    if (!week || week < 1 || week > 53) return null
    return comp(isoWeekMonday(refOf(context), week))
  },
})

export default de
